'use strict';

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var slicedToArray = require('../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var PropTypes = require('prop-types');
var PersonOutline = require('../../node_modules/@material-ui/icons/PersonOutline.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Avatar = require('../../node_modules/@material-ui/core/esm/Avatar/Avatar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function HCAvatar(_ref) {
  var avatarUrl = _ref.avatarUrl,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      theRest = objectWithoutProperties(_ref, ["avatarUrl", "firstName", "lastName"]);

  var _useState = React.useState('20px'),
      _useState2 = slicedToArray(_useState, 2),
      fontSize = _useState2[0],
      setFontSize = _useState2[1];

  var measuredRef = React.useCallback(function (node) {
    if (node !== null) {
      var divHeight = node.getBoundingClientRect().height;
      setFontSize(0.6 * divHeight);
    }
  }, []);
  var avatar = React__default["default"].createElement(Avatar["default"], _extends["default"]({
    alt: "".concat(firstName, " ").concat(lastName),
    src: avatarUrl
  }, theRest), React__default["default"].createElement(PersonOutline, null));

  if (ObjectHelper.isPresent(avatarUrl)) {
    avatar = React__default["default"].createElement(Avatar["default"], _extends["default"]({
      alt: "".concat(firstName, " ").concat(lastName),
      src: avatarUrl
    }, theRest));
  } else if (ObjectHelper.isPresent(firstName) || ObjectHelper.isPresent(lastName)) {
    avatar = React__default["default"].createElement(Avatar["default"], theRest, React__default["default"].createElement("div", {
      style: {
        fontSize: fontSize,
        height: 'inherit',
        width: 'inherit',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inherit'
      },
      ref: measuredRef
    }, ObjectHelper.isPresent(firstName) && firstName.length > 0 ? firstName[0] : '', ObjectHelper.isPresent(lastName) && lastName.length > 0 ? lastName[0] : ''));
  }

  return avatar;
}

HCAvatar.propTypes = {
  avatarUrl: PropTypes__default["default"].string,
  firstName: PropTypes__default["default"].string,
  lastName: PropTypes__default["default"].string
};

module.exports = HCAvatar;
